import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.css';

import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useContext, useState } from 'react';
import { getRestaurantThunk } from './store/restaurant';
import Context from './Context';
import { Route, Routes } from 'react-router-dom';
import OnlineOrder from './Pages/OnlineOrder';
import CheckoutPage from './Pages/Checkout';
import ScrollToTop from './elements/ScrollToTop';
import OrderConfirmed from './Pages/OrderPlaced';
import Header from './elements/Header';
import Home from './Pages/Home';
import Receipt from './Pages/Receipt';
import Menu from './Pages/menu';
import ContactUs from './Pages/Contact';
import AboutUs from './Pages/About';
import ImageGallery from './Pages/Gallery';
import LoadingOverlay from './Pages/Loading'; // Add this import for LoadingOverlay
import ReservationPage from './Pages/Reservation';

function App() {
  const dispatch = useDispatch();
  const restaurant = useSelector((state) => state.restaurants.restaurant);
  const { restaurantId } = useContext(Context);
  useEffect(() => {
    dispatch(getRestaurantThunk(restaurantId));
  }, [dispatch, restaurantId]); // Add restaurantId to the dependency array

  const isLunchTime = () => {
    const now = new Date();
    const estNow = new Date(
      now.toLocaleString('en-US', { timeZone: 'America/New_York' })
    );
    const hour = estNow.getHours(); // 0–23
    const minutes = estNow.getMinutes();
  
    // Lunch ends at 4:00 PM sharp
    return hour < 16 || (hour === 16 && minutes === 0);
  };
  
  const LUNCH_CATEGORY_IDS = [410,411,412]; // ✅ Lunch category IDs
  
  const filteredRestaurant = restaurant
    ? {
        ...restaurant,
        Categories: restaurant.Categories.filter(category => {
          if (LUNCH_CATEGORY_IDS.includes(category.id)) {
            // If it's a lunch special category, only show it during lunch time
            return isLunchTime();
          }
          return true; // Always keep other categories
        })
      }
    : restaurant;
  

  return (
    <div className="App">

      <Header />
      <ScrollToTop />

      <Routes>
        <Route exact path='/' element={<Home restaurant={restaurant} />} />
        <Route path="/order" element={<OnlineOrder restaurant={filteredRestaurant} />} /> 
        <Route path='/checkout' element={<CheckoutPage fee={restaurant?.Restaurant_Fees[0]} />} />
        <Route path='/orderconfirmed' element={<OrderConfirmed />} />
        <Route path='/order/:id/:restaurant_id' element={<Receipt />} />
        <Route path='/menu' element={<Menu restaurant={restaurant} />} />
        <Route path='/contact' element={<ContactUs />} />
        <Route path='/about' element={<AboutUs />} />
        <Route path='/gallery' element={<ImageGallery />} />
        <Route path='/reservation' element={<ReservationPage />} />
      </Routes>
    </div>
  );
}

export default App;
